import type {
  CatalogListOptions,
  CatalogPage,
  CatalogRepository,
} from '#/domain/catalog/CatalogRepository'
import type { CatalogMetric } from '#/domain/catalog/CatalogMetric'

export class GetCatalogMetricListUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    options: CatalogListOptions,
    search?: string,
    applicationId?: string,
    datasource?: string,
  ): Promise<CatalogPage<CatalogMetric>> {
    return this.repository.findMetrics(options, search, applicationId, datasource)
  }
}
